import React from 'react';

var defaultImg = require("../default.json")


var ListViewImage = React.createClass({
  render: function(){
  		var img = "";
  		if(this.props.value["grid_layout_image"] == "null" || !this.props.value["grid_layout_image"]){
  			img = <img src={defaultImg.DEFAULT_IMAGE} alt="" title="" className="img-responsive" local/>;
  		}
  		else{
  			img = <img src={this.props.value["grid_layout_image"]} alt="" title="" className="img-responsive" />;
  		}
    return(
        <div className="theme-list__first-col">
            <div className="theme-list__img">
              {img}
            </div>
        </div>
      );
  }
});

export {ListViewImage};


/** WEBPACK FOOTER **
 ** ./html/components/ListViewImage.jsx
 **/